export default "__VITE_ASSET__B55woWZS__"